import { render, staticRenderFns } from "./demostrador.html?vue&type=template&id=69b2c000&"
import script from "./demostrador.ts?vue&type=script&lang=ts&"
export * from "./demostrador.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports